import dayjs from 'dayjs';

export type RfiBulkExportRow = {
  rfi_log_id: number;
};

export const buildRfiBulkExportRows = (
  selectedRfis: { id: number }[],
): RfiBulkExportRow[] =>
  selectedRfis.map((rfi) => ({
    rfi_log_id: rfi.id,
  }));

export const getRfiBulkExportFilename = (date: Date = new Date()): string =>
  `rfi_log_${dayjs(date).format('YYYY-MM-DD')}.pdf`;
